import React from "react"
import PillStatus from "../../../../../gd-components/molecules/pill/pill-status";

export default function FieldStatus_DropdownValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>

                <PillStatus statusId    = {props.option.value}
                            size        = {26}
                            value       = {props.option}
                            onClick     = {props.onClick}
                />
            </div>
            {props.children}
        </React.Fragment>
    );
}